var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPipelinefilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2832 4.25391H3.70117C3.5535 4.25391 3.4375 4.3699 3.4375 4.51758V8.73445C3.4375 8.94537 3.6748 9.07195 3.84885 8.95591L4.49219 8.52876L5.43088 7.90123C5.50469 7.84851 5.54687 7.76939 5.54687 7.67976V4.51758C5.54687 4.3699 5.43088 4.25391 5.2832 4.25391Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54687 4.51758V7.67976C5.54687 7.76939 5.50467 7.84851 5.43088 7.90123L4.49219 8.52876V4.25391H5.2832C5.43088 4.25391 5.54687 4.3699 5.54687 4.51758Z",
    fill: "#C5C5C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71094 1.58203L5.54687 4.78125H3.4375L0.273438 1.58203L0.653107 1.31836H8.28379L8.71094 1.58203Z",
    fill: "#FFDF40"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71094 1.58203L5.54687 4.78125H4.49219V1.31836H8.28379L8.71094 1.58203Z",
    fill: "#FFBE40"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71094 0.263672V1.58203H0.273438V0.263672C0.273438 0.115998 0.389436 0 0.537109 0H8.44726C8.59494 0 8.71094 0.115998 8.71094 0.263672Z",
    fill: "#17ACE8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71094 0.263672V1.58203H4.49219V0H8.44727C8.59494 0 8.71094 0.115998 8.71094 0.263672Z",
    fill: "#1689FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelinefilter);
export default __webpack_public_path__ + "static/media/pipelinefilter.c1021a5513779ec286613ada0526ba07.svg";
export { ForwardRef as ReactComponent };